/**
 * This class stores the pages thumbnails that are used in pdf outline
 */
export class PDFViewerOutlineImagesCache {
  private pagesImageCache: Map<number, string> = new Map();

  setThumbnail = (pageNumber: number, thumbnailData: string) => this.pagesImageCache.set(pageNumber, thumbnailData);

  getThumbnail = (pageNumber: number) => this.pagesImageCache.get(pageNumber);

  cleanup = () => {
    this.pagesImageCache.clear();
  };
}
